import clsx from 'clsx'
import { Draggable } from 'react-beautiful-dnd'

import { type TaskDomain } from '../../../../types/domain/task-domain'
import { CollaboratorButton } from './CollaboratorButton'
import { truncateWithEllipsis } from '../../../../utils/truncateWithEllipsis'

type Props = {
  task: TaskDomain
  index: number
  onTaskClick: (task: TaskDomain) => void
}

export const Card = ({ task, index, onTaskClick }: Props) => {
  const responsible = task.admin ?? task.researcher

  return (
    <Draggable draggableId={`${task.id}`} key={task.id} index={index}>
      {(provided) => (
        <div
          className={clsx('bg-[#F4F4F4] gap-3 p-6 rounded-[10px] h-fit', {
            'opacity-50': task.done,
          })}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          onClick={() => onTaskClick(task)}
          // isDragging={snapshot.isDragging}
        >
          <div className="min-h-[70px] flex flex-col justify-between gap-3">
            <p
              className="text-sm font-normal break-words text-grey-900"
            >
              {truncateWithEllipsis(task.name, 100)}
            </p>
            {responsible && (
              <CollaboratorButton
                collaborator={{
                  name: responsible.name,
                  email: responsible.email,
                }}
              />
            )}
          </div>
        </div>
      )}
    </Draggable>
  )
}
